import React, { useState, useEffect, useCallback } from "react";
import DashboardForm from "../components/Dashboard";
import LedgerService from "../services/LedgerService";
import headService from "../services/HeadService";
import { useLoading } from "../context/LoadingContext";
import { showErrorToast } from "../utils/AlertUtils";
import { useAuth } from "../context/AuthContext";
import AdminUserService from "../services/admin/AdminUserService";
import AdminApprovalRequestService from "../services/admin/AdminApprovalRequestService";

const Dashboard = () => {
  const { setIsLoading } = useLoading();
  const [headCount, setHeadCount] = useState(0);
  const [totalGrant, setTotalGrant] = useState(0);
  const [userCounts, setUserCounts] = useState(0);
  const [usedGrant, setUsedGrant] = useState(0);
  const [approvalRequestCount, setApprovalRequestCount] = useState(0);
  const [remainingGrant, setRemainingGrant] = useState(0);
  const { isAdminUser } = useAuth();

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      if(!isAdminUser) {
        const [headsResponse, ledgerResponse] = await Promise.all([
          headService.getHeads(),
          LedgerService.ledgerCalculations(),
        ]);
        
        if (headsResponse?.statusCode === 200) {
          setHeadCount(headsResponse?.data?.length || 0);
        }
  
        if (ledgerResponse?.statusCode === 200) {
          setTotalGrant(ledgerResponse?.data?.totalGrant || 0);
          setUsedGrant(ledgerResponse?.data?.usedGrant || 0);
          setRemainingGrant(ledgerResponse?.data?.remainingGrant || 0);
        }
      } else {
        const usersResponse = await AdminUserService.getUsers();
        const approvalRequests = await AdminApprovalRequestService.getApprovalRequests();
        if(usersResponse && usersResponse.statusCode === 200) {
          setUserCounts(usersResponse?.data?.length);
        }
        if(approvalRequests && approvalRequests.statusCode === 200) {
          setApprovalRequestCount(approvalRequests?.data?.length);
        }
      }
    } catch (error) {
      console.error("Error fetching dashboard data", error);
      showErrorToast(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, isAdminUser]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <DashboardForm
      totalGrant={totalGrant}
      usedGrant={usedGrant}
      remainingGrant={remainingGrant}
      headCount={headCount}
      userCounts={userCounts}
      isAdminUser={isAdminUser}
      approvalRequestCount={approvalRequestCount}
    />
  );
};

export default Dashboard;